import axiosInstance from '../../../config/axios.config';

export const paymentService = {
    /**
     * Decrypt payment token and get payment context
     */
    async decryptToken(token) {
        try {
            const response = await axiosInstance.post('/credit-recharge/decrypt-token', {
                token: token
            });
            return response.data;
        } catch (error) {
            console.error('Token decryption failed:', error);
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to decrypt payment token'
            };
        }
    },

    /**
     * Confirm payment after Razorpay success
     */
    async confirmPayment(paymentData) {
        try {
            const response = await axiosInstance.post('/credit-recharge/confirm', paymentData);
            return response.data;
        } catch (error) {
            console.error('Payment confirmation failed:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Payment confirmation failed'
            };
        }
    },

    /**
     * Generate payment token for cross-tenant redirect
     */
    async generatePaymentToken(orderData) {
        try {
            const response = await axiosInstance.post('/credit-recharge/generate-token', orderData);
            return response.data;
        } catch (error) {
            console.error('Token generation failed:', error);
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to generate payment token'
            };
        }
    }
};
